import { api } from "shared/api";

export const STANDARD_PRODUCT_CATEGORIES_QUERY_KEY =
  "standard-product-categories" as const;

export const fetchStandardProductCategoriesData = async () => {
  const { data } = await api().gersGetStandardProductCategories();
  return data;
};
